module.exports = __webpack_public_path__ + "img/page_img_4_5.92a51021.png";